import { isAfter, isBefore } from 'date-fns';
import * as R from 'ramda';

import { CustomCertificateInput } from '@/types';

export const validateCustomCertificateValues = (
  values: CustomCertificateInput,
) => {
  const errors: Record<string, string> = {};
  const decimalNumberRegex = /^(\d*\.)?\d+$/i;

  if (R.isNil(values.title) || values.title === '') {
    errors.title = 'Please enter the name of the course/seminar.';
  } else if (values.title.length > 255) {
    errors.title = 'Please enter a name that is below 255 characters.';
  }

  if (values.description && values.description?.length > 2000) {
    errors.description =
      'Please enter a course description that is below 2000 characters.';
  }

  if (R.isNil(values.credit) || values.credit === '') {
    errors.credit = 'Please enter the amount of hours completed.';
  } else if (!decimalNumberRegex.test(values.credit)) {
    errors.credit = 'Hours must be a number.';
  } else if (
    parseFloat(values.credit) <= 0 ||
    parseFloat(values.credit) >= 1000
  ) {
    errors.credit = 'Please enter a number above 0 and under 1000.';
  }

  if (
    values.deliveryMethod === 'Please Select' &&
    values.complianceType === 'CPE'
  ) {
    errors.deliveryMethod = 'Please select a delivery method.';
  }

  if (values.provider === 'Other' && R.isNil(values.otherProvider)) {
    errors.otherProvider = 'Please enter the name of the provider.';
  } else if (
    values.provider === 'Please Select' &&
    values.complianceType === 'CPE'
  ) {
    errors.provider = 'Please select a provider.';
  }

  if (R.isNil(values.dateCompleted)) {
    errors.dateCompleted = 'Please enter a valid date.';
  } else {
    if (isBefore(values.dateCompleted, new Date(2012, 8, 1))) {
      errors.dateCompleted = 'Date cannot be before 2012-09-01.';
    }

    const nextYear = new Date().getFullYear() + 1;
    if (isAfter(values.dateCompleted, new Date(nextYear, 11, 31))) {
      errors.dateCompleted = `Date cannot be after ${nextYear}-12-31.`;
    }
  }

  if (values.file && values.file!.size > 2 ** 20 * 10) {
    errors.file = 'The selected file is above 10 MB.';
  }

  // if (values.complianceType === 'CPE' && values.location === 'Please Select') {
  //   errors.location = 'Please select a state.';
  // }

  if (
    values.complianceType === 'CPE' &&
    !values.fieldOfStudy?.[0]?.fieldOfStudyId
  ) {
    errors.fieldOfStudy = 'Please select a field of study.';
  }

  return errors;
};

export const CERT_FILE_TYPES = [
  'application/pdf',
  'image/*',
  'text/plain',
  'text/csv',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];
